import {
	PERSONAL_BROKERAGE,
	ROTH_IRA,
	TRADITIONAL_IRA,
} from 'stash/constants/accountTypes';
import BANK_ACCOUNT_PARTNER_TYPE from 'stash/constants/partnerType';

export const hasFilingStatus = (state) => {
	return !!state?.entities?.investor_application?.filing_status;
};

export const hasIncomeBracketOver6k = (state) => {
	const householdIncome = state?.entities?.investor_application?.household_income_bracket;
	return !!householdIncome && householdIncome !== 'UNDER_6K';
};

export const _getRetireAccount = (state) => {
	const rothAccountId = state.entities?.account_by_type.ROTH_IRA;
	const tradAccountId = state.entities?.account_by_type.TRADITIONAL_IRA;
	const retireAccountId = rothAccountId || tradAccountId;

	return retireAccountId && state.entities?.account[retireAccountId];
};

export const hasRetireAccountType = (state) => {
	const tempRetireAccountType = state?.application?.signUp?.data?.retireAccountType;
	const retireAccount = _getRetireAccount(state);
	const retireAccountType = retireAccount && retireAccount.type;
	return !!(tempRetireAccountType || retireAccountType);
};

export const hasEsigAccount = (state, type) => {
	const acctId = state?.entities?.account_by_type?.[type];
	return !!state?.entities?.account?.[acctId]?.e_signature_agreed_at;
};

export const hasRetireEsig = (state) => {
	return hasEsigAccount(state, TRADITIONAL_IRA) || hasEsigAccount(state, ROTH_IRA);
};

export const hasSeenInvestValueProp = (state) => {
	return state?.application?.signUp?.completed?.['invest-addon'];
};

export const hasInvestEsig = (state) => {
	return hasEsigAccount(state, PERSONAL_BROKERAGE);
};

export const hasAutoStash = (state) => {
	const auto_stash = state?.application?.signUp?.data?.auto_stash ?? {};
	return !!(auto_stash.amount && auto_stash.frequency);
};

export const hasBankLinked = (state) => {
	const externalAccount = state?.entities?.externalAccount;

	return !!(externalAccount && externalAccount.bankAccount?.state);
};

export const hasNoBankLinked = (state) => {
	return !hasBankLinked(state);
};

export const skippedBankLinkRetireAddOn = (state) => {
	return state?.application?.signUp?.completed?.['skip-bank-link-add-on'];
};

export const hasConfirmedAddress = (state) => {
	return state?.application?.signUp?.completed?.['debit-confirm-address'];
};

export const hasConfirmedEnrollment = (state) => {
	return state?.application?.signUp?.completed?.['debit-confirm-info'];
};

export const hasStashBankAccount = (state) => {
	return (
		state?.entities?.bank?.debit_accounts?.length > 0 &&
		state?.entities?.bank?.debit_accounts?.some(
			(account) => account.partnerType === BANK_ACCOUNT_PARTNER_TYPE.STRIDE
		)
	);
};

export const hasStashDebitAndNoBankLinked = (state) => {
	return hasNoBankLinked(state) && hasStashBankAccount(state);
};

export const hasStashDebitAndHasBankLinked = (state) => {
	return hasBankLinked(state) && hasStashBankAccount(state);
};
